import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/vendors/$vendorId` activates the vendor-record column
// (col 2). The Vendors LAYOUT route (vendors.tsx) reads `$vendorId` from the
// leaf match and renders every column via ColumnLayout. Mirrors lodging/$bookingId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/vendors/$vendorId")({
  component: () => null,
})
